<template>
    <PageBreadcrumbs />
    <MyTabbar />
    <AllSearchForm />
    <AllResults />
</template>

<script>
import PageBreadcrumbs from "@/components/pages/PageBreadcrumbs.vue";
import MyTabbar from "../components/Tabbar.vue";
import AllSearchForm from "../components/forms/AllSearchForm.vue";
import AllResults from "../components/results/AllResults.vue";

import { SearchKey, useAllSearch } from "../composables/useAllSearch.js";

import { defineComponent, provide } from "vue";

export default defineComponent({
    components: {
        PageBreadcrumbs,
        MyTabbar,
        AllSearchForm,
        AllResults,
    },

    setup() {
        // 初期値を設定
        provide(SearchKey, useAllSearch());
    },
});
</script>

<style scoped></style>
